import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './index.css';
import { IoClose } from 'react-icons/io5';

import homeicon from '../../assests/karaicon.svg';
import privateclientbgimg from '../../assests/privateclientbgimg.png';
import Footer from '../Footer';

const PrivateClient = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isConceptOpen, setIsConceptOpen] = useState(false);

const toggleConceptMenu = () => {
  setIsConceptOpen(!isConceptOpen);
};

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      {/* Navbar - Always Visible */}
      <nav className="private-client-navbar">
        <div className="private-client-navbar-logo">
          <Link to="/">
            <img src={homeicon} alt="Kara Logo" className="private-client-logo-icon" />
          </Link>
        </div>
        <div className="private-client-navbar-menu" onClick={toggleMenu}>
          <svg xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49" fill="none" className="private-client-hamburger-icon">
            <circle cx="24.5" cy="24.5" r="24" fill="black" stroke="#9A9A9A"/>
            <rect x="13" y="16" width="24" height="3" rx="1.5" fill="#9A9A9A"/>
            <rect x="13" y="23" width="24" height="3" rx="1.5" fill="#9A9A9A"/>
            <rect x="13" y="30" width="24" height="3" rx="1.5" fill="#9A9A9A"/>
          </svg>
        </div>
      </nav>

      {/* Navigation Menu Overlay */}
      {isMenuOpen && (
        <div className="private-client-nav-overlay">
          <div className="private-client-nav-close" onClick={toggleMenu}>
            <IoClose className="private-client-close-icon" />
          </div>
          <nav className="private-client-navigation">
            <ul className="private-client-nav-list">
              <li><Link to="/about" onClick={toggleMenu}>About US</Link></li>
              <li><Link to="/process" onClick={toggleMenu}>Our Process</Link></li>
              <li><Link to="/services" onClick={toggleMenu}>Services</Link></li>
              <li><Link to="/collections" onClick={toggleMenu}>Collections & Products</Link></li>
              <li><Link to="/sustainability" onClick={toggleMenu}>Sustainability & Ethical Sourcing</Link></li>
              <li className="active"><Link to="/private-client" onClick={toggleMenu}>Private Client Services</Link></li>
              {/* <li><Link to="/hospitality" onClick={toggleMenu}>Hospitality & Commercial Solutions</Link></li>
              <li><Link to="/journal" onClick={toggleMenu}>Journal / Blog</Link></li> */}
              {/* <li className="nav-item-with-submenu">
                <span className="nav-concept-trigger" onClick={toggleConceptMenu}>
                  Concept <span className="dropdown-arrow">▼</span>
                </span>
                {isConceptOpen && (
                  <ul className="concept-submenu">
                    <li><Link to="/concept-1" onClick={toggleMenu}>Concept-1</Link></li>
                    <li><Link to="/concept-2" onClick={toggleMenu}>Concept-2</Link></li>
                  </ul>
                )}
              </li> */}
              <li><Link to="/concept" onClick={toggleMenu}>concept</Link></li>
              <li><Link to="/contact" onClick={toggleMenu}>Contact Us</Link></li>
            </ul>
          </nav>
        </div>
      )}

      {/* SECTION 1: Hero */}
      <section className="private-client-section-1">
        {/* Background Image */}
        <div className="private-client-section-1-background">
          <img src={privateclientbgimg} alt="Private Client Background" className="private-client-section-1-bg-image" />
        </div>

        {/* Overlay */}
        <div className="private-client-section-1-overlay"></div>

        {/* Bottom Content */}
        <div className="private-client-section-1-content">
          <p className="private-client-section-1-label">Private Client Services</p>
          <h1 className="private-client-section-1-title">
            Ultra-Personalized Luxury, By <br/>Invitation Only
          </h1>
          <p className="private-client-section-1-description">
            At Studio Kara, we cater to high-net-worth individuals and collectors who seek more than design—they seek legacy. Our private client services offer an intimate, one-on-one experience that brings your vision to life through timeless, bespoke creations.
          </p>
        </div>
      </section>

      {/* SECTION 2: Gallery Section */}
      <section className="private-client-section-2">
        <div className="private-client-section-2-gallery">
          <div className="private-client-section-2-image-wrapper">
            <img 
              src={require('../../assests/section3-image1.jpg')} 
              alt="Crafted Furniture 1" 
              className="private-client-section-2-image" 
            />
            <p className="private-client-section-2-image-title">Private home styling & décor consulting.</p>
          </div>
          <div className="private-client-section-2-image-wrapper">
            <img 
              src={require('../../assests/section3-image2.jpg')} 
              alt="Crafted Furniture 2" 
              className="private-client-section-2-image" 
            />
            <p className="private-client-section-2-image-title">One-on-one collaboration to create bespoke heirloom pieces.</p>
          </div>
          <div className="private-client-section-2-image-wrapper">
            <img 
              src={require('../../assests/section3-image3.png')} 
              alt="Crafted Furniture 3" 
              className="private-client-section-2-image" 
            />
            <p className="private-client-section-2-image-title">Early access to limited-edition collections.</p>
          </div>
        </div>
      </section>

      {/* SECTION 3: CTA Button */}
        <section className="private-client-section-3">
        <Link to="/contact">
            <button className='private-client-section-3-cta-button'>
            Request an Exclusive Consultation
            </button>
        </Link>
        </section>

        <Footer/>
    </>
  );
};

export default PrivateClient;